import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_OKR_SESSION,
    StoreType,
    OkrSessionProps,
    LoadOkrSessionById,
    setOkrSessionView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import SessionContent from "./sessionContent"

const View = ({
    sessionId = null,
}: OkrSessionProps) => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)
    const reloadView = useSelector((state: StoreType) => state.okrSession.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadOkrSessionById(sessionId, userData.accountId).then((res) => {
            dispatch(setOkrSessionView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = hasAccess(PRM_OKR_SESSION, VIEW)

    const isOwner = session && session.owner === userData.userId
    const allowedToView = viewAccess || isOwner

    if (!session) return <NotFound />
    if (!allowedToView) return <AccessDenied />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{session.name}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                {
                    session.id
                    && <SessionContent />
                }
            </PageContent>
        </Container>
    )
}
export default View
